import { useQuery } from 'react-query'

import type { TrendDetectionService } from 'features/trend-detection/service/service'
import type { IssueAgentResponse } from 'features/trend-detection/types'

export interface UseAgentResult {
  agent: IssueAgentResponse | null
  isLoading: boolean
  isError: boolean
}

export function useAgent(
  service: TrendDetectionService,
  projectId: string | null,
  agentUuid: string | null,
): UseAgentResult {
  const {
    data: agentData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['trend-agent', projectId, agentUuid],
    queryFn: async () => {
      if (!projectId || !agentUuid) throw new Error('missing')
      // `checkStaleFilters: true` populates `agent.stale_filters` server-side
      // — otherwise it's null and the header chip has no data.
      return service.fetchAgent(projectId, agentUuid, {
        checkStaleFilters: true,
      })
    },
    enabled: !!projectId && !!agentUuid,
    retry: false,
  })

  return {
    agent: agentData ?? null,
    isLoading,
    isError,
  }
}
